/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Pipe, PipeTransform} from "@angular/core";

import {OgTranslateService} from './og-translate.service';

@Pipe({standalone: false, name: 'ogTranslate'})
export class OgTranslatePipe implements PipeTransform {
  constructor(private readonly ogTranslate: OgTranslateService) {
  }

  transform(key: string, defaultText?: string, interpolateParams?: object): string {
    return this.ogTranslate.transform(key, defaultText, interpolateParams);
  }
}
